import { withChartLayout } from 'components/common';
import GenitourinaryAssessment from 'components/features/chart/system-assessment/genitourinary-assessment/GenitourinaryAssessment';

const GenitourinaryAssessmentPage = withChartLayout('Genitourinary Assessment')(GenitourinaryAssessment);
export default GenitourinaryAssessmentPage;
